import { ticketLib } from "@agentcall/core/lib"
import { ticketType } from "@agentcall/core/type"
import { Select } from "@/components/ui/select"

// 型をエクスポート
export type TicketCategory = ticketType.category
export type TicketSubCategory = ticketType.subCategory

// 後方互換性のため、ticketLibからSUBCATEGORIES_BY_CATEGORYを再エクスポート
export const SUBCATEGORIES_BY_CATEGORY = ticketLib.SUBCATEGORIES_BY_CATEGORY

// 大カテゴリのオプション
const categoryOptions = ticketType.TICKET_CATEGORIES.map((item) => ({
  value: item.key,
  label: item.value,
}))

// 中カテゴリのオプションを取得
export const getSubCategoryOptions = (category: ticketType.category | undefined) => {
  if (!category || !SUBCATEGORIES_BY_CATEGORY[category]) {
    return []
  }
  return SUBCATEGORIES_BY_CATEGORY[category].map((item) => ({
    value: item.key,
    label: item.value,
  }))
}

interface TicketCategorySelectorProps {
  categoryValue: TicketCategory | ""
  subCategoryValue: TicketSubCategory | ""
  onCategoryChange: (value: TicketCategory | "") => void
  onSubCategoryChange: (value: TicketSubCategory | "") => void
  categoryError?: string
  subCategoryError?: string
  categoryPlaceholder?: string
  subCategoryPlaceholder?: string
  className?: string
  disabled?: boolean
}

export function TicketCategorySelector({
  categoryValue,
  subCategoryValue,
  onCategoryChange,
  onSubCategoryChange,
  categoryError,
  subCategoryError,
  categoryPlaceholder = "大カテゴリ",
  subCategoryPlaceholder = "中カテゴリ",
  className,
  disabled = false,
}: TicketCategorySelectorProps) {
  const subCategoryOptions = getSubCategoryOptions(categoryValue || undefined)

  const handleCategoryChange = (value: TicketCategory | "") => {
    onCategoryChange(value)
    // カテゴリ変更時に中カテゴリをクリア
    onSubCategoryChange("")
  }

  return (
    <div className={className}>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Select
            value={categoryValue}
            onChange={(value) => handleCategoryChange(value as TicketCategory | "")}
            options={categoryOptions}
            placeholder={categoryPlaceholder}
            className="w-full"
            disabled={disabled}
          />
          {categoryError && <p className="text-xs text-red-500">{categoryError}</p>}
        </div>
        <div className="space-y-2">
          <Select
            value={subCategoryValue}
            onChange={(value) => onSubCategoryChange(value as TicketSubCategory | "")}
            options={subCategoryOptions}
            placeholder={subCategoryPlaceholder}
            disabled={!categoryValue || disabled}
            className="w-full"
          />
          {subCategoryError && <p className="text-xs text-red-500">{subCategoryError}</p>}
        </div>
      </div>
    </div>
  )
}
